// Supported asset classes in the admin opportunity form.
// Keep this list small and explicit to reflect currently supported deal mechanics.
// Additional asset classes can be re-enabled once their deal mechanics are implemented.
export type AssetsClass =
  | 'Trade Finance'
  | 'Private Credit'
  | 'Private Equity'
  | 'Mutual Fund'
  | 'Listed Equity'

/** Legacy asset classes still stored on existing opportunities (read-only in the form). */
export type LegacyAssetsClass = 'Fixed Income' | 'Real Estate' | 'Bridge Round' | 'Funds of Funds'

export type AllAssetsClass = AssetsClass | LegacyAssetsClass

export type PublishingStatus = 'PUBLISHED' | 'UNPUBLISHED' | 'LINK_ONLY' | 'CLOSED'

export const assetsClass: AssetsClass[] = [
  'Private Equity',
  'Private Credit',
  'Trade Finance',
  'Mutual Fund',
  'Listed Equity',
]

export const legacyAssetsClass: LegacyAssetsClass[] = [
  'Fixed Income',
  'Real Estate',
  'Bridge Round',
  'Funds of Funds',
]

export const allAssetsClass: AllAssetsClass[] = [...assetsClass, ...legacyAssetsClass]
export const publishedStatus: PublishingStatus[] = [
  'PUBLISHED',
  'UNPUBLISHED',
  'LINK_ONLY',
  'CLOSED',
]
